import { ApiService } from "./api.service";
export default class RateService extends ApiService {
  template = "defaultTemplate";
  namespace = "rates";
  icon = "Invoice";
  action = "action";
  favicon = "DocumentWithText";
  action_lable = this.t("delete");
  inactive = 1;
  Width = 600;
  DOMAIN = -6;
  name = "Rate";
  singular = this.name;
  plural = this.name + "s";
  vowel = "a";
  constructor() {
    super("rates");
  }
}
